<template lang="html">
  <b-form id="trips-page" @submit="onSubmit">

    <loading-s1 v-if="loading"></loading-s1>

    <!-- Sección Menu para modificar viaje -->
    <section class="top-section">
      <div class="container" data-aos="fade-in" data-aos-duration="1000">
        <div class="row">
          <div class="col col-filters">
            <a class="btn-filter" @click="openSearchModal(true)"><i class="fa-sharp fa-regular fa-filter-list icon"></i> Modificar viaje</a>
          </div>

          <div class="col col-trip-info" @click="openSearchModal(true)">
            <div class="text">Zapopan</div>
            <div  class="arrow"><i class="fa-regular fa-arrow-right-long"></i></div>
            <div class="text">Los Mochis</div>
            <div  class="number">1</div>
            <div class="text">Pasajeros</div>
            <div class="calendars">
              <div class="b-calendar">
                <span class="label">Ida:</span>
                17/Septiembre/2024
              </div>

              <div class="b-calendar">
                <span class="label">Vuelta:</span>
                18/Septiembre/2024
              </div>
            </div>
          </div>

          <div class="col col-button">
            <a class="btn btn-search" @click="openSearchModal(true)">
              <span class="d-none d-lg-inline">BUSCAR DE NUEVO</span>
              <span class="d-lg-none"><i class="fa-solid fa-magnifying-glass"></i> BUSCAR</span>
            </a>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Sección boletos disponibles (paso 1) -->
    <section class="results-section" v-if="step == 1">
      <div class="container" data-aos="fade-in" data-aos-duration="500">
        <div class="row">
          <div class="col-12 col-short-info">
            <div class="box-destinations">
              <span>Zapopan</span>
              <i class="fa-light fa-arrow-right-long icon"></i>
              <span>Los Mochis</span>
            </div>
            <h5 class="title-1"><strong>Seleccione el horario de ida: </strong> <span>07-nov-2024</span></h5>
          </div>

          <div class="col-12 col-trip" v-for="(trip, tInx) in trips" :key="'tInx-'+tInx">
            <div class="box-trip-information">
              <div class="col col-icon">
                <img src="public/images/pages/trips/icon-time-1.svg" v-if="trip.icon == 1">
                <img src="public/images/pages/trips/icon-time-2.svg" v-if="trip.icon == 2">
                <img src="public/images/pages/trips/icon-time-3.svg" v-if="trip.icon == 3">
              </div>

              <div class="col col-schedule">
                <span>{{ trip.depTime }}</span>
              </div>
              <div class="col col-arrow">
                <i class="line"></i>
                <span class="txt">Directo</span>
                <i class="fa-regular fa-arrow-right-long arrow"></i>
              </div>
              <div class="col col-schedule">
                <span>{{ trip.arrivalTime }}</span>
              </div>
              <div class="col col-time">
                <span>2 hrs 20 mins</span>
              </div>
              <div class="col col-available">
                <span>8 Menores</span>
                <span>8 INSEN</span>
              </div>
              <div class="col col-id">
                <span>ID: 38245</span>
              </div>
              <div class="col col-seats" v-if="trip.freeSeats">
                <span class="seats">QUEDAN {{ trip.freeSeats }}</span>
              </div>
              <div class="col col-price">
                <span class="price">$455.00
                  <small>MXN</small>
                </span>
              </div>
              <div class="col col-button">
                <button class="btn btn-buy" type="button" @click="goStep2()">COMPRAR</button>
              </div>
            </div>
          </div>
        </div>
      </div>


    </section>
    <!--  -->

    <!-- Sección pasos activos (pasos 2 al 4) -->
    <section class="steps-section" v-if="step >= 2">
      <div class="container" data-aos="fade-in" data-aos-duration="500">
        <div class="row">
          <div class="col-12 col-steps-st-1">
            <div class="row">
              <div class="col-4 col-step">
                <div class="b-step" v-bind:class="{ 'active' : step >= 2 }">
                  SELECCIONA ASIENTO
                </div>
              </div>

              <div class="col-4 col-step">
                <div class="b-step" v-bind:class="{ 'active' : step >= 3 }">
                  INGRESA TU INFO
                </div>
              </div>

              <div class="col-4 col-step">
                <div class="b-step" v-bind:class="{ 'active' : step >= 4 }">
                  REALIZA TU PAGO
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Secciones seleccionar asiento (paso 2), agregar info de los pasajeros (paso 3), pagar boletos (paso 4) -->
    <section class="bus-seats-section" v-if="step == 2">
      <div class="container" data-aos="fade-in" data-aos-duration="500">
        <div class="row">
          <div class="col-12 col-short-bus-info">
            <div class="box-short-bus-info">
              <div class="col col-text">
                <h5>Elige los asientos que necesites.</h5>
                <p>
                  Posteriormente solicitaremos que vacies los datos de los pasajeros.
                </p>
              </div>

              <div class="col col-seats-info">
                <div class="col-4 col-seat">
                  <div class="b-color seat-1"></div>
                  <h6>Ocupado</h6>
                </div>

                <div class="col-4 col-seat">
                  <div class="b-color seat-2"></div>
                  <h6>Libre</h6>
                </div>

                <div class="col-4 col-seat">
                  <div class="b-color seat-3"></div>
                  <h6>Seleccionado</h6>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-bus-seats">
            <div class="box-vehicle-container">
              <div class="no-gutters box-vehicle">
                <div class="col col-front-vehicle">
                  <!-- <img src="public/images/pages/trips/bus-front-v.svg"> -->
                </div>

                <div class="col col-vehicle-seats">
                  <b-form-checkbox-group class="col-12 content" v-model="form.seats" name="seats">
                    <!-- Fila 1 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="4" disabled>4</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="3">3</b-form-checkbox></div>
                      </div>

                      <div class="col col-aisle"></div>

                      <!-- <div class="col col-seat"></div> -->

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="2">2</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="1">1</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 1 end -->

                    <!-- Fila 2 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="8" disabled>8</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="7">7</b-form-checkbox></div>
                      </div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="6">6</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="5">5</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 2 end -->

                    <!-- Fila 3 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="12">12</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="11">11</b-form-checkbox></div>
                      </div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="10">10</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="9">9</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 3 end -->

                    <!-- Fila 4 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="16" disabled>16</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="15">15</b-form-checkbox></div>
                      </div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="14">14</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="13">13</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 4 end -->

                    <!-- Fila 5 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="20">20</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="19">19</b-form-checkbox></div>
                      </div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="18">18</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="17">17</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 5 end -->

                    <!-- Fila 6 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="24">24</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="23">23</b-form-checkbox></div>
                      </div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="22">22</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="21">21</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 6 end -->

                    <!-- Fila 7 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="28">28</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="27">27</b-form-checkbox></div>
                      </div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="26">26</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="25">25</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 7 end -->

                    <!-- Fila 8 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="32">32</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="31">31</b-form-checkbox></div>
                      </div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="30">30</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="29">29</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 8 end -->

                    <!-- Fila 9 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="36">36</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="35">35</b-form-checkbox></div>
                      </div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="34">34</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="33">33</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 9 end -->

                    <!-- Fila 10 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="40">40</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="39">39</b-form-checkbox></div>
                      </div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="38">38</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="37">37</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 10 end -->

                    <!-- Fila 11 -->
                    <div class="row">
                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="42">42</b-form-checkbox></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat"></div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat"></div>

                      <div class="col col-space"></div>

                      <div class="col col-seat">
                        <div class="seat"><b-form-checkbox value="41">41</b-form-checkbox></div>
                      </div>
                    </div>
                    <!-- 11 end -->

                    <!-- Fila 12 -->
                    <div class="row">
                      <div class="col col-toilets">
                        <div class="toilets"></div>
                      </div>

                      <div class="col col-space"></div>

                      <div class="col col-seat"></div>

                      <div class="col col-aisle"></div>

                      <div class="col col-seat"></div>

                      <div class="col col-space"></div>

                      <div class="col col-seat"></div>
                    </div>
                    <!-- 12 end -->
                  </b-form-checkbox-group>
                </div>

                <div class="col col-rear-vehicle">
                  <!-- <img src="public/images/pages/trips/bus-rear-v.svg"> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <section class="container passengers-section" v-if="step == 3">
      <div class="box" data-aos="fade-in" data-aos-duration="500">
        <div class="row">
          <div class="col-12 mb-4 col-info">
            <h5>Ingresa tus datos tal como aparecen en tu identificación.</h5>
            <p>
              Ademas de tu telefono y correo, alli llegara tu confirmacion de compra.
            </p>
          </div>

          <div class="col-12 col-passenger-form">
            <div class="box-passenger" v-for="(p, pInx) in 3" :key="'pInx-'+pInx">
              <div class="row">
                <div class="col-12 col-passenger-info">
                  <div class="d-block pb-2">
                    <div class="b-passenger">
                      <i class="fas fa-user-alt icon"></i> <span>Pasajero {{ pInx+1 }}</span>
                    </div>
                    <div class="b-seat"><i class="fa-solid  fa-seat-airline icon"></i> Asiento {{ 18 + pInx}}</div>
                    <div class="b-seat"><i class="fa-solid  fa-seat-airline icon"></i> Asiento {{ 2 + pInx }}</div>
                  </div>
                </div>

                <div class="col-md-6">
                  <b-form-group class="custom-f-group-s1">
                    <b-form-input
                      v-model="names[pInx]"
                      type="text"
                      placeholder="Nombre(s)"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group class="custom-f-group-s1">
                    <b-form-input
                      v-model="lastNames[pInx]"
                      type="text"
                      placeholder="Apellidos"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6" v-if="pInx == 0">
                  <b-form-group class="custom-f-group-s1">
                    <b-form-input
                      v-model="form.phone"
                      minlength="10"
                      maxlength="10"
                      type="text"
                      placeholder="Teléfono movil"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6" v-if="pInx == 0">
                  <b-form-group class="custom-f-group-s1">
                    <b-form-input
                      v-model="form.email"
                      type="text"
                      placeholder="Correo electrónico"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6 ml-auto">
                  <b-form-group class="custom-f-group-s1">
                    <b-form-select required class="form-select" v-bind:class="{ 'text-muted' : categories[pInx] == '' }" v-model="categories[pInx]">
                      <b-form-select-option :value="''">Categoría</b-form-select-option>
                      <b-form-select-option value="1">Adulto</b-form-select-option>
                      <b-form-select-option value="2">Menor</b-form-select-option>
                      <b-form-select-option value="3">Insen</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mt-1 col-info">
            <p>
              <img src="public/images/pages/trips/id.svg" class="icon-1" /> Recuerda que deberás presentar una identificación oficial para abordar el autobús.
            </p>
            <p class="mt-2">
              <img src="public/images/pages/trips/people.svg" class="icon-1" /> Menores de edad deben viajar con la compañia de un adulto.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="container payments-section" v-if="step == 4">
      <div class="box" data-aos="fade-in" data-aos-duration="500">
        <div class="row">
          <div class="col-12 mb-4 col-info">
            <h5>Procesa tu pago de manera segura.</h5>
            <p>
              Ingresa tus datos.
            </p>
          </div>

          <div class="col-12 col-form">
            <p class="mb-3 mb-sm-4 text-center">
              <img class="img-payment" src="public/images/pages/trips/payments.svg">
            </p>

            <div class="row pt-2 pb-3 justify-content-center">
              <div class="col-lg-8 mb-3">
                <b-form-group class="custom-f-group-s1">
                  <b-form-input
                    v-model="form.cardName"
                    type="text"
                    placeholder="Nombre como aparece en la tarjeta"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-8 mb-3">
                <b-form-group class="custom-f-group-s1">
                  <b-form-input
                    v-model="form.cardNumber"
                    type="text"
                    maxlength="16"
                    placeholder="Numero en la tarjeta"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-12"></div>

              <div class="col-lg-4 mb-3">
                <b-form-group class="custom-f-group-s1">
                  <b-form-input
                    v-model="form.cardcvv"
                    type="text"
                    placeholder="CVV & CVC"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 mb-3">
                <b-form-group class="custom-f-group-s1">
                  <b-form-datepicker v-model="form.cardExp" dropup :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" placeholder="Fecha de exp."></b-form-datepicker>
                </b-form-group>
              </div>

              <div class="col-lg-8">
                <div class="d-block">
                  <b-form-checkbox
                    v-model="form.checkboxTerms"
                    name="checkbox-1"
                    required
                    :value="true"
                    :unchecked-value="false">
                    Acepto <router-link to="/terminos-y-condiciones"><u>los términos y condiciones de usuario de AVIP S.A. de C.V.</u></router-link>
                  </b-form-checkbox>
                </div>

                <div class="d-block pt-2">
                  <b-form-checkbox
                    v-model="form.checkboxDev"
                    name="checkbox-1"
                    required
                    :value="true"
                    :unchecked-value="false">
                    Acepto <router-link to="/terminos-y-condiciones"><u>las condiciones de devolución.</u></router-link>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Sección inferior (botones prev - next) -->
    <section class="container bottom-section" v-if="step <= 4">
      <!-- Step 2 (selección de asientos) -->
      <div class="col-button-info-st-1" v-if="step == 2">
        <div class="t-150 b-info st-1" @click="goStep3()">
          <div class="b-text">
            Asiento seleccionado: <span>{{ form.seats.length }}</span>
          </div>

          <div class="ml-auto b-next">
            Continuar <i class="far fa-long-arrow-right icon-arrow"></i>
          </div>
        </div>
      </div>
      <!-- 2 -->

      <!-- Step 3 (pasajeros) -->
      <div class="col-button-info-st-1" v-if="step == 3">
        <div class="t-150 b-info st-1" @click="goStep4()">
          <div class="ml-auto b-next">
            Continuar <i class="far fa-long-arrow-right icon-arrow"></i>
          </div>
        </div>
      </div>
      <!-- 3 -->

      <!-- Step 4 (pago) -->
      <div class="col-button-info-st-1" v-if="step == 4">
        <b-button type="submit" class="w-100 b-info st-2">
          <div class="mx-auto mr-sm-0 ml-sm-auto b-finish">
            PAGAR $455.00 <i class="far fa-long-arrow-right icon-arrow"></i>
          </div>
        </b-button>
      </div>
      <!-- 4 -->
    </section>
    <!--  -->

    <!-- Sección Compra completada (boletos) -->
    <section class="container ticket-section" v-if="step == 5">
      <div class="box" data-aos="fade-in" data-aos-duration="500">
        <div class="box-information">
          <!-- <Checkbox1Component></Checkbox1Component> -->

          <i class="fa-solid fa-circle-check icon-check"></i>

          <h2 class="mb-3 title-1">¡Listo!</h2>

          <p class="mb-2 mb-sm-4">
            Tu pago fué procesado y tus asientos fueron reservados.<br />
            ¡Buen viaje!
          </p>

          <h5 class="title-2">Aquí tu boleto:</h5>
        </div>

        <!-- Boleto ida -->
        <div class="box-ticket-st-1">
          <div class="b-ticket">
            <div class="ins">
              <div class="col col-detail">
                <div class="b-logo">
                  <img src="public/images/logo.svg">
                </div>

                <div class="b-ticket-info">
                  <h6 class="title-1"><strong>ADULTO</strong><span> | </span>BOLETO ÚNICO, NO TRANSFERIBLE PARA:</h6>
                  <h3 class="name">JOSE DE JESUS TORRES AMEZCUA</h3>

                  <div class="b-trip-info st-1">
                    <div class="text">Guadalajara</div>
                    <div class="arrow"><i class="fa-solid fa-arrow-right-long"></i></div>
                    <div class="text">Guasave</div>

                    <div class="col-right id-desktop">ID: 38245</div>
                  </div>

                  <div class="b-trip-info st-2">
                    <div class="text">05:40 AM</div>
                    <div class="arrow"><i class="fa-regular fa-clock"></i></div>
                    <div class="text">08:30 PM</div>

                    <div class="col-right">
                      <span class="id-mobile">ID: 38245<br /></span>
                      ASIENTO: 20
                    </div>
                  </div>

                  <h3 class="code">49843487984758758HH484HG474DEDEDEE4951</h3>
                </div>
              </div>

              <div class="col col-qr">
                <img src="public/images/pages/trips/qr.png">

                <h6>FECHA</h6>
                <h5>29/NOV/2024</h5>
              </div>
            </div>
          </div>
        </div>
        <!--  -->

        <!-- Boleto vuelta -->
        <div class="box-ticket-st-1">
          <div class="b-ticket">
            <div class="ins">
              <div class="col col-detail">
                <div class="b-logo">
                  <img src="public/images/logo.svg">
                </div>

                <div class="b-ticket-info">
                  <h6 class="title-1"><strong>MENOR</strong><span> | </span>BOLETO ÚNICO, NO TRANSFERIBLE PARA:</h6>
                  <h3 class="name">JOSE DE JESUS TORRES AMEZCUA</h3>

                  <div class="b-trip-info st-1">
                    <div class="text">Guasave</div>
                    <div class="arrow"><i class="fa-solid fa-arrow-right-long"></i></div>
                    <div class="text">Guadalajara</div>

                    <div class="col-right id-desktop">ID: 80045</div>
                  </div>

                  <div class="b-trip-info st-2">
                    <div class="text">07:00 PM</div>
                    <div class="arrow"><i class="fa-regular fa-clock"></i></div>
                    <div class="text">10:10 PM</div>

                    <div class="col-right">
                      <span class="id-mobile">ID: 4005<br /></span>
                      ASIENTO: 3
                    </div>
                  </div>

                  <h3 class="code">13563487984d5258206H484HG474DEDEDEEXB20</h3>
                </div>
              </div>

              <div class="col col-qr">
                <img src="public/images/pages/trips/qr.png">

                <h6>FECHA</h6>
                <h5>10/DIC/2024</h5>
              </div>
            </div>
          </div>
        </div>
        <!--  -->

        <div class="box-info">
          <h4 class="title-1">Tu boleto fue enviado a:</h4>

          <h6 class="title-2">Tu WhatsApp: <strong>3340510082</strong> y a tu correo: <strong>jesus@sustam.com</strong></h6>
        </div>
      </div>
    </section>
    <!--  -->

    <b-modal v-model="$root.modalTrips" modal-class="modal-search-trips" ref="modal-search" hide-footer no-close-on-backdrop no-close-on-esc title="">
      <BoxSearchComponent></BoxSearchComponent>
    </b-modal>

  </b-form>
</template>

<script>
import BoxSearchComponent from './box-search-component.vue';
import Checkbox1Component from '../shared/checkbox-an-component.vue'
export default {
  components: {
    BoxSearchComponent, Checkbox1Component
  },

  data() {
    return {
      loading: true,
      step: 1, // 5 (boletos pagados), 4 (pago), 3 (pasajeros), 2 (asientos), 1 (viajes disponibles)
      idaVuelta: false,

      form: {
        seats: [],
        passengers: [],
        cardExp: null,
      },

      names: [],
      lastNames: [],
      categories: ['','',''],

      trips: [
        { icon: 1, id: 38245, depTime: '05:40 AM', arrivalTime: '8:00 AM', freeSeats: 4 },
        { icon: 1, id: 38246, depTime: '07:00 AM', arrivalTime: '9:20 AM', freeSeats: null },
        { icon: 1, id: 38247, depTime: '08:10 AM', arrivalTime: '10:30 AM', freeSeats: null },
        { icon: 1, id: 38247, depTime: '08:20 AM', arrivalTime: '10:40 AM', freeSeats: 3 },
        { icon: 1, id: 38248, depTime: '09:40 AM', arrivalTime: '12:00 AM', freeSeats: null },
        { icon: 2, id: 38249, depTime: '11:00 AM', arrivalTime: '01:20 PM', freeSeats: null },
        { icon: 2, id: 38250, depTime: '02:00 PM', arrivalTime: '04:20 PM', freeSeats: null },
        { icon: 3, id: 38251, depTime: '06:40 PM', arrivalTime: '08:00 PM', freeSeats: null },
        { icon: 3, id: 38251, depTime: '08:00 PM', arrivalTime: '10:20 PM', freeSeats: null },
      ],
    }
  },

  methods: {
    openSearchModal(isModal) {
      this.$root.modalTrips = true;
      this.$refs['modal-search'].show();
    },

    goStep2() {
      this.$router.push( { name: 'tripsPage', params: {step: "asientos"} } );
    },

    goStep3() {
      this.$router.push( { name: 'tripsPage', params: {step: "pasajeros"} } );
    },

    goStep4() {
      this.$router.push( { name: 'tripsPage', params: {step: "pago"} } );
    },

    onSubmit(event) {
      event.preventDefault();

      this.step = 5;
      // this.$router.push( { name: 'tripsPage', params: {step: "boletos"} } );
    },
  },

  beforeMount() {
    // Evitar que el usuario pueda iniciar en alguna vista que no sea la primera
    if(this.$route.params.step != null && this.step == 1) {
      this.$router.push( { name: 'tripsPage' } );
    }
  },

  mounted() {
    setTimeout(()=>{
      this.loading = false;
    }, 2000);
  },

  watch: {
    "$route.params.step"(step) {
      if(step == 'pago') {
        this.step = 4;
      }
      else if(step == 'pasajeros') {
        this.step = 3;
      }
      else if(step == 'asientos') {
        this.step = 2;
      }
      else {
        this.step = 1;
      }
    }
  }
}
</script>
